<template>
  <div>
    <router-view></router-view>
    <SessionWarning v-if="authState.isAuthenticated" />
    <PendingInvitationsModal
      v-if="pendingInvitations.length > 0"
      :invitations="pendingInvitations"
      v-model:invitations="pendingInvitations"
      @accepted="onInvitationAccepted"
      @skipped="pendingInvitations = []"
    />
  </div>
  <footer></footer>
</template>

<style scoped>
footer {
  height: 120px;
}
</style>

<script>
import { inject, ref, watch, onBeforeUnmount } from 'vue'
import SessionWarning from '@/components/SessionWarning.vue'
import PendingInvitationsModal from '@/components/PendingInvitationsModal.vue'
import { sessionMonitor } from '@/auth'
import { useFundStore } from '@/stores/fund'
import { useUserStore } from '@/stores/user'
import { UsersApi } from '@/api/users_api'

export default {
  components: { SessionWarning, PendingInvitationsModal },

  setup() {
    const authState = inject('authState')
    const fundStore = useFundStore()
    const userStore = useUserStore()
    const pendingInvitations = ref([])

    async function checkPendingInvitations() {
      try {
        const results = await UsersApi.getPendingInvitations()
        pendingInvitations.value = results || []
      } catch (e) {
        // Non-fatal — user may not have any pending invitations or endpoint may not exist yet
        pendingInvitations.value = []
      }
    }

    function onInvitationAccepted() {
      pendingInvitations.value = []
      // Reload to pick up new tenant context
      window.location.reload()
    }

    // Initialize stores and session monitor when authenticated
    watch(() => authState.isAuthenticated, (isAuthenticated) => {
      if (isAuthenticated) {
        sessionMonitor.start()
        fundStore.initializeFunds()
        userStore.initializeUsers()
        checkPendingInvitations()
      } else {
        sessionMonitor.stop()
        fundStore.$reset()
        userStore.$reset()
        pendingInvitations.value = []
      }
    })

    onBeforeUnmount(() => {
      sessionMonitor.stop()
    })

    return { authState, pendingInvitations, onInvitationAccepted }
  }
}
</script>
